import { Registry } from '@react-registry'

export const H6Deserializer = () => {
  return {
    type: 'h6'
  }
}

Registry.register(H6Deserializer, { id: 'H6', registry: 'v2.deserializer' })
